<style scoped>
.pdd {
  margin: 0 80px;
}
</style>
<template lang="pug">
    form.pdd
      .row
        .col.s12#actions
      .row
        .col.s12.m12.input-field
          span(v-if='reseller.bankinfos[0].bankName !== "null"') {{reseller.bankinfos[0].bankName}}
          label.active(for='name') Bank Name :
        .col.s12.m12.input-field
          span(v-if='reseller.bankinfos[0].accountNumber !== "null"') {{reseller.bankinfos[0].accountNumber}}
          label.active(for='name') Account Number :
        .col.s12.m12.input-field
          span(v-if='reseller.bankinfos[0].accountType !== "null"') {{reseller.bankinfos[0].accountType}}
          label.active(for='name') Account Type :
      
        
</template>
<script>
export default {
  props: ['reseller']
};
</script>



// WEBPACK FOOTER //
// src/components/app-bank-details.vue